import { Item, ItemActions, ItemDescription, ItemHeader, ItemTitle, TextWithDescription } from '@ibsys/kit';
import { TruncatedText } from '@/shared/ui';
import { ReactNode } from 'react';
import { cn } from '@/shared/lib';

type NestedItemCardProps<T> = {
  item: T;
  renderTitle: (item: T) => ReactNode;
  /** Отличительный признак записи (например, код) — под названием; пустой не показывается */
  renderHint?: (item: T) => ReactNode;
  /** Описание записи строкой под названием; пустое не показывается */
  renderDescription?: (item: T) => ReactNode;
  /** Кнопка исключения записи из состава */
  action?: ReactNode;
  className?: string;
};

/** Строка состава вложенного списка карточки. */
export const NestedItemCard = <T,>({
  item,
  renderTitle,
  renderHint,
  renderDescription,
  action,
  className,
}: NestedItemCardProps<T>) => {
  const hint = renderHint?.(item);
  const description = renderDescription?.(item);

  return (
    <Item variant="outline" className={cn('min-w-0', className)} size={'sm'}>
      <ItemHeader className="min-w-0">
        <ItemTitle className="min-w-0 wrap-break-word">
          {hint ? (
            <TextWithDescription
              className="min-w-0"
              text={renderTitle(item)}
              description={<span className="font-mono">{hint}</span>}
            />
          ) : (
            renderTitle(item)
          )}
        </ItemTitle>
        {action && <ItemActions className="ml-4 shrink-0">{action}</ItemActions>}
      </ItemHeader>
      {description && (
        <ItemDescription className="min-w-0 text-sm text-muted-foreground">
          <TruncatedText>{description}</TruncatedText>
        </ItemDescription>
      )}
    </Item>
  );
};
